export default __webpack_public_path__ + "static/care-karts-40f02a52f5fa2fd7b83e26840dce0ede.svg";